import SummaryTranslation from "../../model/translations/SummaryTranslation";
import { formatBooleanValue } from "../../../util";

const SummaryTranslationMapper = (item: any) => {
  let summaryTranslation = SummaryTranslation(item);
  summaryTranslation.valid = formatBooleanValue(item.valid);

  return summaryTranslation;
};

export default SummaryTranslationMapper;
